import React, { useState, useMemo } from 'react';
import { DndContext, closestCenter, useSensor, useSensors, PointerSensor, DragOverlay } from '@dnd-kit/core';
import { arrayMove } from '@dnd-kit/sortable';
import { Box, Container } from '@mui/material';
import POSHeader from 'components/POSHeader';
import { ThemeProvider } from 'theme/ThemeContext2';
import ServeStatusColumn from 'components/ServeStatusColumn';
import ServeStatusColumnSkeleton from 'components/ServeStatusColumn/ServeStatusColumnSkeleton';
import ServeOrderCard from 'components/ServeOrderCard';
import ServeSummary from 'components/ServeSummary';
import { servePanelStatusList } from 'utils/constant';



export default function ServeContainer({ orders, columns, setColumns, onStatusChange, validTransitions, stations, serveSummary, selectedChef,
  onChefChange, onFetch,
  orderLoading,
  isLoading = false
}) {
  const [activeId, setActiveId] = useState(null);

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } })
  );

  // map orders by id
  const ordersMap = useMemo(() => orders.reduce((a, o) => ({ ...a, [o.id]: o }), {}), [orders]);

  const handleArrowClick = (id, from, dir) => {
    const idx = servePanelStatusList.findIndex(s => s.key === from);
    const toIdx = dir === 'forward' ? idx + 1 : idx - 1;
    if (toIdx < 0 || toIdx >= servePanelStatusList.length) return;
    onStatusChange(id, from, servePanelStatusList[toIdx].key);
  };

  return (
    <ThemeProvider>
      <Box sx={{ bgcolor: "#fff", display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <POSHeader />
        <Container maxWidth={false} disableGutters sx={{ flexGrow: 1, p: 3, maxWidth: 1400, mx: 'auto' }}>
          {/* <Box sx={{ position: "sticky", top: "65px", zIndex: 100, padding: "5px 0", background: "#f5f5f5" }}> */}
          <ServeSummary
            chefs={stations}
            selectedChef={selectedChef}
            onChefChange={onChefChange}
            serveSummary={serveSummary}
            onFetch={onFetch}
            orderLoading={orderLoading}
            isLoading={isLoading}
          />
          {/* </Box> */}
          <Box>

          </Box>
          {isLoading ? (
            <Box className='serve-status-column d-flex' sx={{ gap: '30px' }}>
              {Array.from({ length: 4 }).map((_, colIdx) => (
                <ServeStatusColumnSkeleton key={colIdx} />
              ))}
            </Box>
          ) : (
            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragStart={({ active }) => setActiveId(active.id)}
              onDragEnd={({ active, over }) => {
                setActiveId(null);
                if (!over) return;

                const from = Object.keys(columns).find(k => columns[k].includes(active.id));
                const to = Object.keys(columns).includes(over.id)
                  ? over.id
                  : Object.keys(columns).find(k => columns[k].includes(over.id));
                if (!from || !to) return;

                if (from === to) {
                  // reorder
                  const oldIx = columns[from].indexOf(active.id);
                  const newIx = columns[to].indexOf(over.id);
                  setColumns(prev => ({
                    ...prev,
                    [from]: arrayMove(prev[from], oldIx, newIx),
                  }));
                } else {
                  onStatusChange(active.id, from, to);
                }
              }}
            >
              <Box className='serve-status-column d-flex' sx={{ gap: '30px' }}>
                {servePanelStatusList.map(s => (
                  <ServeStatusColumn
                    key={s.key}
                    statusKey={s.key}
                    label={s.label}
                    color={s.color}
                    textColor={s.textColor}
                    items={columns[s.key]}
                    ordersMap={ordersMap}
                    onArrowClick={handleArrowClick}
                    validTransitions={validTransitions}
                    onReorder={ids => setColumns(c => ({ ...c, [s.key]: ids }))}
                  />
                ))}
              </Box>

              <DragOverlay>
                {activeId && (
                  <Box>
                    <ServeOrderCard
                      order={ordersMap[activeId]}
                      from={Object.keys(columns).find(k => columns[k].includes(activeId))}
                      onArrowClick={handleArrowClick}
                      validTransitions={validTransitions}
                    />
                  </Box>
                )}
              </DragOverlay>
            </DndContext>
          )}
        </Container>
      </Box>
    </ThemeProvider>
  );
}
